import { useEffect, useState } from 'react'
import { GuidelineConfigurationWithAsset, ProductVariant } from '../types'
import { IGuidelineAsset } from '../components/GuidelineDownload'

export default function useGuidelines({
  guidelineConfiguration,
  selectedVariant,
}: {
  guidelineConfiguration: GuidelineConfigurationWithAsset
  selectedVariant: ProductVariant
}): { guidelineAssets: IGuidelineAsset[]; selectedVariantOptions: string[] } {
  const [fileUrls, setFileUrls] = useState<IGuidelineAsset[]>([])
  const selectedVariantSKU = selectedVariant.styleCode

  useEffect(() => {
    const bundles = guidelineConfiguration.bundles || {}
    const styleCodesPrefixMap = guidelineConfiguration.styleCodesPrefixMap || {}

    const styleCodePrefixMapKey = Object.keys(styleCodesPrefixMap)?.find(
      (styleCode) => selectedVariantSKU.includes(styleCode)
    )

    const selectedBundleId = styleCodesPrefixMap[styleCodePrefixMapKey]

    const bundleAssets = bundles[selectedBundleId]

    setFileUrls(bundleAssets)
  }, [selectedVariantSKU])

  const selectedVarientOptions = guidelineConfiguration?.fieldsVisibility
    ?.map((fieldToShow) => {
      const fieldValue = selectedVariant[fieldToShow.key] || null

      if (fieldValue !== null) {
        return `${fieldToShow.label}: ${fieldValue}`
      } else {
        return ''
      }
    })
    .filter(Boolean)

  return {
    guidelineAssets: fileUrls,
    selectedVariantOptions: selectedVarientOptions,
  }
}
